import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { CHECKOUT_URL } from '../lib/config';
export function Hero() {
  return <section className="relative overflow-hidden bg-gradient-to-br from-mc-dark to-mc-gray pt-20 pb-16 px-5 border-b-[3px] border-mc-yellow" data-id="element-85">
      {/* Radial glow accent */}
      <div className="absolute -top-[60px] -right-[60px] w-[300px] h-[300px] bg-[radial-gradient(circle,rgba(245,200,0,0.1),transparent_70%)] pointer-events-none" data-id="element-86" />

      <div className="max-w-[760px] mx-auto flex flex-col items-center text-center relative z-10" data-id="element-87">
        <FadeIn data-id="element-88">
          <span className="inline-block bg-mc-yellow text-mc-dark text-xs font-display tracking-widest uppercase py-1.5 px-3.5 rounded mb-4" data-id="element-89">
            🛡️ Dejá de pagar de más
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.1] mb-5 text-balance" data-id="element-90">
            Dejá de <em className="text-mc-yellow not-italic" data-id="element-91">regalarle</em>{' '}
            plata al taller
          </h1>
          <p className="text-lg text-mc-text leading-relaxed mb-8 max-w-[520px] mx-auto" data-id="element-92">
            Aprendé a detectar estafas, evitar sobreprecios y hacer
            mantenimientos básicos de auto y moto sin depender 100% del
            mecánico.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-93">
          <div className="flex flex-wrap justify-center gap-2.5 mb-8" data-id="element-94">
            <span className="bg-mc-gray2 border border-mc-gray3 text-gray-200 text-xs font-bold py-1.5 px-3.5 rounded-full flex items-center gap-1.5" data-id="element-95">
              <span className="text-mc-yellow" data-id="element-96">⚡</span> Acceso inmediato
            </span>
            <span className="bg-mc-gray2 border border-mc-gray3 text-gray-200 text-xs font-bold py-1.5 px-3.5 rounded-full flex items-center gap-1.5" data-id="element-97">
              <span className="text-mc-yellow" data-id="element-98">📱</span> Formato digital
            </span>
            <span className="bg-mc-gray2 border border-mc-gray3 text-gray-200 text-xs font-bold py-1.5 px-3.5 rounded-full flex items-center gap-1.5" data-id="element-99">
              <span className="text-mc-yellow" data-id="element-100">🇦🇷</span> Hecho para Argentina
            </span>
            <span className="bg-mc-gray2 border border-mc-gray3 text-gray-200 text-xs font-bold py-1.5 px-3.5 rounded-full flex items-center gap-1.5" data-id="element-101">
              <span className="text-mc-yellow" data-id="element-102">🔧</span> No necesitás ser
              mecánico
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-103">
          <Button size="large" href={CHECKOUT_URL} data-id="element-104">
            🛡️ Quiero el Pack Taller Blindado
          </Button>
        </FadeIn>
      </div>
    </section>;
}